import * as Sentry from '@sentry/react';
import _ from 'lodash';
import React from 'react';
import { CSVLink } from 'react-csv';

import { date as commonDate } from '@finley-technologies/common';

import { DownloadIconButton } from './IconButton';

export interface CsvDownloadButtonProps {
  dataRows: { [key: string]: any }[];
  headers: { label: string; key: any }[];
  filenamePrefix: string;
  buttonLabel?: string;
  dataIsLoading?: boolean;
}

export const CsvDownloadButton = ({
  dataRows,
  headers,
  filenamePrefix,
  buttonLabel = 'Export CSV',
  dataIsLoading,
}: CsvDownloadButtonProps) => {
  const todayFullDateStr = commonDate.currentDateStr();
  const filename = `${filenamePrefix}-${todayFullDateStr}.csv`;

  return (
    // !TODO @eldarshamukhmedov react-csv is no longer maintained, needs to be replaced
    <CSVLink data={dataRows} headers={headers} filename={filename}>
      <DownloadIconButton
        label={buttonLabel}
        ariaLabel={_.lowerCase(buttonLabel) || 'download csv'}
        isLoading={dataIsLoading}
        onClick={() => {
          Sentry.addBreadcrumb({
            category: 'ui.click',
            message: `Clicked Export CSV to download ${filename}`,
            level: Sentry.Severity.Info,
          });
        }}
      />
    </CSVLink>
  );
};
